import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

import Login from './pages/Login';
import Layout from './components/Layout';
import Pipeline from './pages/Pipeline';
import Leads from './pages/Leads';
import LeadDetail from './pages/LeadDetail';
import DropDetail from './pages/DropDetail';
import Reports from './pages/Reports';
import AddLead from './pages/AddLead';
import UploadLeads from './pages/UploadLeads';
import Sources from './pages/Sources';
import Team from './pages/Team';
import MyTasks from './pages/MyTasks';
import Drop from './pages/Drop';
import Settings from './pages/Settings';
import ActiveDeals from "./pages/ActiveDeals";
import WonDeals from "./pages/WonDeals";
import LostDeals from "./pages/LostDeals";
import DealDetail from "./pages/DealDetail";
import DealStages from "./pages/DealStages";
import DealLostReasons from "./pages/DealLostReasons";
import LeadStages from "./pages/LeadStages";
import DropReasons from "./pages/DropReasons";
import SourceMaster from "./pages/SourceMaster";
import PipelineStages from "./pages/PipelineStages";
import DataMigration from "./pages/DataMigration";
import GlobalSearch from "./pages/GlobalSearch";
import Export from "./Export";

import './App.css';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <p>Loading Aranyaka CRM...</p>
      </div>
    );
  }

  return user ? children : <Navigate to="/login" replace />;
}

function RoleRoute({ children, allowedRoles }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <p>Loading Aranyaka CRM...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    return <Navigate to="/pipeline" replace />;
  }

  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>

          <Route path="/login" element={<Login />} />

          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="/pipeline" replace />} />

            {/* Common Routes */}
            <Route path="pipeline" element={<Pipeline />} />
            <Route path="leads" element={<Leads />} />
            <Route
  path="drop"
  element={
    <RoleRoute allowedRoles={['admin', 'sales_head']}>
      <Drop />
    </RoleRoute>
  }
/>

<Route
  path="drop/:id"
  element={
    <RoleRoute allowedRoles={['admin', 'sales_head']}>
      <DropDetail />
    </RoleRoute>
  }
/>
            <Route path="leads/:id" element={<LeadDetail />} />
            <Route path="leads/add" element={<AddLead />} />
            <Route path="tasks" element={<MyTasks />} />
            <Route path="search" element={<GlobalSearch />} />
            <Route path="deals" element={<ActiveDeals />} />
            <Route path="deals/:id" element={<DealDetail />} />
            <Route path="deals/won" element={<WonDeals />} />
            <Route path="deals/lost" element={<LostDeals />} />

            {/* Admin Only */}
            <Route
              path="upload"
              element={
                <RoleRoute allowedRoles={['admin']}>
                  <UploadLeads />
                </RoleRoute>
              }
            />
            

            <Route
              path="sources"
              element={
                <RoleRoute allowedRoles={['admin']}>
                  <Sources />
                </RoleRoute>
              }
            />
<Route
  path="export"
  element={
    <RoleRoute allowedRoles={['admin']}>
      <Export />
    </RoleRoute>
  }
/>
            <Route
              path="team"
              element={
                <RoleRoute allowedRoles={['admin', 'sales_head']}>
                  <Team />
                </RoleRoute>
              }
            />
            

            <Route
              path="settings"
              element={
                <RoleRoute allowedRoles={['admin']}>
                  <Settings />
                </RoleRoute>
              }
            />
            <Route
  path="settings/data-migration"
  element={
    <RoleRoute allowedRoles={["admin"]}>
      <DataMigration />
    </RoleRoute>
  }
/>
              <Route
  path="settings/pipeline-stages"
  element={
    <RoleRoute allowedRoles={['admin', 'sales_head']}>
      <PipelineStages />
    </RoleRoute>
  }
/>


            <Route
              path="settings/deal-stages"
              element={
                <RoleRoute allowedRoles={['admin']}>
                  <DealStages />
                </RoleRoute>
              }
            />

            <Route
              path="settings/deal-lost-reasons"
              element={
                <RoleRoute allowedRoles={['admin']}>
                  <DealLostReasons />
                </RoleRoute>
              }
            />

            <Route
              path="settings/lead-stages"
              element={
                <RoleRoute allowedRoles={['admin']}>
                  <LeadStages />
                </RoleRoute>
              }
            />

            <Route
              path="settings/drop-reasons"
              element={
                <RoleRoute allowedRoles={['admin']}>
                  <DropReasons />
                </RoleRoute>
              }
            />

            <Route
              path="settings/sources"
              element={
                <RoleRoute allowedRoles={['admin']}>
                  <SourceMaster />
                </RoleRoute>
              }
            />

            {/* Admin + Sales Head + Team Lead + Sales Manager */}
<Route
  path="reports"
  element={
    <RoleRoute
      allowedRoles={[
        'admin',
        'sales_head',
        'team_lead',
        'sales_manager'
      ]}
    >
      <Reports />
    </RoleRoute>
  }
/>

          </Route>

        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}